module.exports = __webpack_public_path__ + "static/img/img_shop_cabinet.ce9b8f32.png";